import IconTurret from './IconTurret';

export default IconTurret;